import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  console.log('Pasando por ErrorInterceptor:', performance.now());

  return next(req).pipe(
    tap((event: HttpEvent<any>) => {
      console.log(`errorInterceptor: Evento recibido (${event.type}):`);
      console.log('errorInterceptor:', performance.now());
    }),
    catchError((error) => {
      console.log('ErrorInterceptor: Error capturado:', error);
      // No redirigir a /login si ya estamos en la página de login
      if (
        (error.status === 401 || error.status === 403) &&
        !req.url.includes('/login')
      ) {
        console.log(
          'ErrorInterceptor: Status 401 o 403 detectado y no estamos en /login. Redirigiendo.'
        );
        router.navigate(['/login-nuevo']);
      }
      return throwError(() => error);
    })
  );
};
